import "../../../static/js/loaders/jquery";

$(".colored-block-container").each(function () {
  if ($(this).attr('data-overlap') == "True") {
    var upperHeight = $(this).children(".colored-block-upper").height()
    $(this).css("margin-top", -upperHeight)
  }
});